/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 11:23:25
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-06-07 16:45:56
 * @FilePath: /dbrank_b/src/routes/visualChart/Layout.js
 * @Description: 结构
 */
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Menu from './Menu';
import s from './VisualChart.css';

class Layout extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    active: PropTypes.string,
  }

  constructor(props) {
    super(props);
  }

  render () {
    const { children, active } = this.props;
    return (
      <div className={s.container}>
        <Menu active={active} />
        <div className={s.content}>
          {children}
        </div>
      </div>
    )
  }
}

export default withStyles(s)(Layout)


// WEBPACK FOOTER //
// src/routes/visualChart/Layout.js